<template>


  <div class="wrapper">

    <v-sidebar v-bind:activeNavItem=navPage></v-sidebar>

    <div class="main-panel">

      <v-navbar v-bind:title="'RFQs'"></v-navbar>

      <div class="content">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-md-12">
                      <div class="card data-tables">
                          <div class="card-body table-no-bordered dataTable dtr-inline table-full-width">
                              <div class="toolbar">
                                  <!-- Here you can write extra buttons/actions for the toolbar -->
                              </div>
                              <div class="fresh-datatables">
                                  <table id="datatables" class="table table-condensed" cellspacing="0" width="100%" style="width:100%">
                                    <thead>
                                      <tr>
                                        <th class="disabled-sorting"></th>
                                        <th>Customer</th>
                                        <th>TO #</th>
                                        <th>Shipper</th>
                                        <th>Consignee</th>
                                        <th>Created</th>
                                        <th>Due Date</th>
                                        <th>Role</th>
                                        <th class="disabled-sorting">Status</th>
                                        <th class="disabled-sorting text-right" style="min-width: 70px">Actions</th>
                                      </tr>
                                    </thead>
                                  </table>

                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

      </div>

      <v-footer></v-footer>

    </div>

  </div>


</template>

<script>
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'

import apiService from '../../services/api.service'

var rows = [];


export default {
  name: 'RFQView',
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer
  },
  computed:
  {
    navPage: function() {
      if (this.$route.query.awarded == "true") {
        return "shipment";
      }
      else {
        return "navLink1";
      }
    }
  },
  watch: {
      '$route.query.awarded'() {
          console.log("awarded changed!");

          if (this.$route.query.awarded == "true") {
            $("#shipment").addClass("active");
            $("#navLink1").removeClass("active");
          }
          else {
            $("#navLink1").addClass("active");
            $("#shipment").removeClass("active");
          }

          sessionStorage.refresh = "true";
          this.refreshList();
      }
  },
  mounted () {

    this.refreshList();


  }, // end mounted


  methods: {
    refreshList: function () {

    console.log("---- refresh");
    var vm = this;

    if (rows.length == 0 || sessionStorage.refresh == "true")
    {
      // Remove old rows from table
      sessionStorage.refresh = "false";
      var rowlen = rows.length
      for (var j = 0; j < rowlen; j++) {
        rows.pop()
      }

      // Get a list of all RFQs
      apiService.get('/kong/api/v1/rfq/')
      .then(function (response) {

        const small = "<small class='text-muted'>"
        const smallend = "</small>"
        const now = new Date();

        // Successfully got a complete list, parse and add to the model
        for (var i = 0; i < response.data.Result.length; i++) {

          const rel = response.data.Result[i]
          // console.log( JSON.stringify(rel,null,2) );

          let rduedate = '--'
          let rduehour = ''
          let bold = "";
          let boldend = "";

          try
          {
            if (rel.duedate) {
              rduedate = rel.duedate;
            } else if(rel.dueDateTime) {
              rduedate = serverTimeToLocalFormat(rel.dueDateTime, "yyyy-mm-dd");
              rduehour = serverTimeToLocalFormat(rel.dueDateTime, "HH:MM");
            }

            var lastUpdated = new Date(rel.updatedAt);
            var rcreatedDate = serverTimeToLocalFormat(rel.createdAt, "yyyy-mm-dd");
            var rcreatedHour = serverTimeToLocalFormat(rel.createdAt, "HH:MM");

            var lastViewedDate = localStorage["lastViewedDate"+rel.id+localStorage.getItem('local_id')];
            if (lastViewedDate == null) lastViewedDate = new Date("2001-01-01 00:00:00");

            if (lastViewedDate < lastUpdated) {
              bold = "<b>";
              boldend = "</b>";
            }

          }
          catch(e) { console.log(e); }


          const combinedId = rel.id + "." + rel.customerid;
          const viewOnly = rel.assignees && rel.assignees.length > 0 && rel.status != 'Draft';
          const editIcon = viewOnly ? "fa-eye" : "fa-pencil";
          const action = viewOnly ? "view" : "edit";

          const rfqCard = {
            "id": rel.id,
            "combinedId": combinedId,
            "customer": bold + rel.customer + "<br>" + small + rel.id + smallend + boldend,
            "customertransferorder": bold + rel.customerTransferOrder + boldend,
            "shipper": bold + rel.shipper + boldend,
            "consignee": bold + rel.consignee + boldend,
            "securitylevel": bold + rel.securitylevel + boldend,
            "created_date": bold + rcreatedDate + "<br>" + small + rcreatedHour + smallend + boldend,
            "due_date": bold + rduedate + "<br>" + small + rduehour + smallend + boldend,
            "role": bold + rel.securitylevel + boldend,
            "status": rel.status + " <small>(" + rel.dispatchStatus + ")</small>",
            "assignees": rel.assignees,
            "actions": `<a href="#/rfq/${action}/${combinedId}" class="btn btn-link btn-info"><i class="fa fa-fw ${editIcon}"></i></a>`,
          }

          if (rel.securitylevel == "Creator" || rel.securitylevel == "Main Customer" || rel.securitylevel == 'Customer Company') {
            rfqCard.actions += '<a onclick="confirmDeleteRFQ(\'' + combinedId + '\')" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>';
          }
          else {
            rfqCard.actions += '<a href="#" class="btn btn-link" disabled><i class="fa fa-fw fa-trash"></i></a>';
          }

          var isDuplicate = false;
          if (rel.assignees != null)
          {
            for (var j = 0; j < rel.assignees.length; j++) {
              var rtag = rel.status == 'Assigned' || rel.status == 'Open' ? 'rfq_received' : 'rfq_orphaned';
              if (rel.assignees[j].quote != null)
              {
                if (rel.assignees[j].quote.status == 'Awarded') {
                  rtag = 'rfq_viewed'
                } else if (rel.assignees[j].quote.status == 'Rejected') {
                  rtag = 'rfq_declined'
                } else if (rel.assignees[j].quote.status == 'Sent' || rel.assignees[j].quote.status == 'Selected') {
                  rtag = 'rfq_sent'
                }
              }

              if (rel.assignees[j].assignerid == rel.assignees[j].assigneeid && rel.securitylevel != "Creator") {
                // when we assign to ourselves don't show the RFQ twice. Just show the Creator version
                isDuplicate = true;
              }

              if (rtag != null) rfqCard.status += '<i class="fa fa-square ' + rtag + '"></i>';
            }
          }

          rfqCard.status = bold + rfqCard.status + boldend;

          if (!isDuplicate) rows.push(rfqCard)

        }

      initDataTable();

      })

    }
    else
    {
      console.log("tables already loaded");
      initDataTable();
    }


    }
  }


}


  function initDataTable() {

    var vm = this;

    // if ( ! $.fn.DataTable.isDataTable('#datatables') ) {

      var mytable = $('#datatables').DataTable({
           "data": rows,
           "columns": [
               {
                   "className": 'details-control',
                   "orderable": false,
                   "defaultContent": '',
                   "render": function () {
                       return '<i class="fa fa-plus-square" aria-hidden="true"></i>';
                   },
               },
               { "data": "customer" },
               { "data": "customertransferorder", "width": "90px" },
               { "data": "shipper" },
               { "data": "consignee" },
               { "data": "created_date", "width": "90px" },
               { "data": "due_date", "width": "90px" },
               { "data": "role" },
               { "data": "status" },
               { "data": "actions", "className": 'text-right' },
           ],
          "order": [[ 5, "desc" ]],
          "pagingType": "full_numbers",
          "lengthMenu": [
              [10, 25, 50, -1],
              [10, 25, 50, "All"]
          ],
          stateSave: true,
          retrieve: true,
          responsive: {
              details: false
          },
          language: {
              search: "_INPUT_",
              searchPlaceholder: "Search records",
          }

      });

      // Add event listener for opening and closing details
      $('#datatables tbody').on('click', 'td.details-control', function () {

          var tr = $(this).closest('tr');
          var row = mytable.row(tr);
          var tdi = tr.find("i.fa");

          var d = row.data();

          if (d.assignees == null) {
            d.assignees = [];
          }
          doRowExpand(d,tr,row,tdi);
          console.log("------ get all assignee names");
          for (var j = 0; j < d.assignees.length; j++)
          {
            loadName(d.assignees[j]);
          }
      });
    // }


    function doRowExpand(d,tr,row,tdi)
    {
        if ( row.child.isShown() ) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            tdi.first().removeClass('fa-minus-square');
            tdi.first().addClass('fa-plus-square');
        }
        else {
            // Open this row
            row.child( formatDetailRow(d) ).show();
            tr.addClass('shown');
            tdi.first().removeClass('fa-plus-square');
            tdi.first().addClass('fa-minus-square');
        }
    }
    console.log("datatables init done!");
  }

  // https://datatables.net/examples/api/row_details.html
  function formatDetailRow ( d ) {

    // d is the original data object for the row
    console.log( "expand row: " + d.id );

    var html =  '<table class="table">'+
      '<thead>'+
          '<tr>'+
            '<th>Assignee</th>'+
            '<th>Delivery Date</th>'+
            '<th>Pickup Date</th>'+
            '<th>Status</th>'+
            '<th>Base Charge</th>'+
            '<th>Border Charge</th>'+
            '<th>Fuel Charge</th>'+
            '<th>Additional Charge</th>'+
            '<th>Total Quote</th>'+
          '</tr>'+
      '</thead>'+
      '<tbody>';


      for (var i = 0; i < d.assignees.length; i++) {

          var thisQuoteId = d.assignees[i].quote != null ? d.assignees[i].quote.id : "";
          var inOut =  d.assignees[i].assigneeid == localStorage.getItem('local_id') ? "[OUT]" : "[IN]";

          var name = d.assignees[i].name != null ? d.assignees[i].name : "";
          var deliverydate = "--";
          var pickupdate = "--";
          var status = "Waiting " + inOut;

          var charges = { total: "--", basecharge: "", bordercharge: "", fuelcharge: "", additionalcharge: ""  };
          if (d.assignees[i].quote != null) {
            deliverydate = safeDate(d.assignees[i].quote.deliverydate, d.assignees[i].quote.deliveryDateTime);
            pickupdate = safeDate(d.assignees[i].quote.pickupdate, d.assignees[i].quote.pickupDateTime);
            status = d.assignees[i].quote.status + " " + inOut;
            charges = getQuoteTotals(d.securitylevel, d.assignees[i].quote);
          }


          html += '<tr>'+
          '<td name="name_' + d.assignees[i].assigneeid + '">' + name + '</td>'+
          '<td>' + deliverydate + '</td>'+
          '<td>' + pickupdate + '</td>'+
          '<td>' + status + '</td>'+
          '<td>' + charges.basecharge + '</td>'+
          '<td>' + charges.bordercharge + '</td>'+
          '<td>' + charges.fuelcharge + '</td>'+
          '<td>' + charges.additionalcharge + '</td>'+
          '<td>' + charges.total + '</td>'+
        '</tr>';
          
      }


    html += '</tbody></table>';
    //console.log(html);

    return html;
  }



  function loadName(d)
  {
    // lazy load the name of the assignee
    if (d.name == null)
    {
      console.log('/ getting assignee details for ' + d.assigneeid);
      apiService.get('/kong/api/v1/entity/id', {
        headers: {'X-Raefton-ID': d.assigneeid}
      }).then(function (response) {
          var rer = response.data.Result
          console.log(rer);
          $("[name=name_"+d.assigneeid+"]").html(rer.name);
          d.name = rer.name;
          console.log("set the name: " + d.name);
      });
    }
    else
    {
      $("[name=name_"+d.assigneeid+"]").html(d.name);
    }
  }

  function getQuoteTotals(securitylevel, quote)
  {
    var charges = {};
    charges.basecharge = "N/A";
    charges.bordercharge = "N/A";
    charges.fuelcharge = "N/A";
    charges.additionalcharge = "N/A";

    var quotecharge;
    if (isNumeric(quote.finalmarkedupcost) && securitylevel == "Creator")
    {
      quotecharge = parseFloat(quote.finalmarkedupcost)
    }
    else if (isNumeric(quote.markedupcost))
    {
      quotecharge = parseFloat(quote.markedupcost)
    }
    else
    {
      var fuelcharge = 0;
      var bordercharge = 0;
      var additionalcharge = 0;
      if (isNumeric(quote.fuelcharge)) {
        fuelcharge = parseFloat(quote.fuelcharge);
        charges.fuelcharge = "$" + parseFloat((quote.fuelcharge * 100)/100).toFixed(2);
      }
      if (isNumeric(quote.bordercharge)) {
        bordercharge = parseFloat(quote.bordercharge);
        charges.bordercharge = "$" + parseFloat((quote.bordercharge * 100)/100).toFixed(2);
      }
      if (isNumeric(quote.additionalcharge)) {
        additionalcharge = parseFloat(quote.additionalcharge);
        charges.additionalcharge = "$" + parseFloat((quote.additionalcharge * 100)/100).toFixed(2);
      }
      if (isNumeric(quote.basecharge)) {
        charges.basecharge = "$" + parseFloat((quote.basecharge * 100)/100).toFixed(2);
      }
      quotecharge = parseFloat(quote.basecharge) + fuelcharge + bordercharge + additionalcharge;
    }

    charges.total = "$" + parseFloat((quotecharge * 100)/100).toFixed(2);
    return charges;
  }


  function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }



</script>



// WEBPACK FOOTER //
// view.vue?9cc25c52